import React from 'react';
import { useLanguage } from '../../../hooks/useLanguage';

const LangToggle: React.FC = () => {
  const [language, setLanguage] = useLanguage();

  return (
    <span className="nav__lang" aria-label="Language">
      <a
        href="?lang=en"
        className={language === 'en' ? 'is-active' : ''}
        aria-current={language === 'en' ? 'page' : undefined}
        onClick={(e) => {
          e.preventDefault();
          setLanguage('en');
        }}
      >
        EN
      </a>
      <span className="nav__lang__sep">/</span>
      <a
        href="?lang=nl"
        className={language === 'nl' ? 'is-active' : ''}
        aria-current={language === 'nl' ? 'page' : undefined}
        onClick={(e) => {
          e.preventDefault();
          setLanguage('nl');
        }}
      >
        NL
      </a>
    </span>
  );
};

export default LangToggle;
